import { Heading } from '@tiptap/extension-heading'

export const CustomHeading = Heading.extend({
    name: 'heading',
    
    addOptions() {
        return {
            ...this.parent?.(),
            levels: [1, 2, 3, 4, 5, 6],
        }
    },

    addAttributes() {
        return {
            level: {
                default: 1,
                rendered: true,
            },
            sectionType: {
                default: null,
                parseHTML: element => element.getAttribute('data-section-type'),
                renderHTML: attributes => {
                    return attributes.sectionType ? { 'data-section-type': attributes.sectionType } : {}
                }
            },
            class: {
                default: null,
                rendered: true
            },
            blockType: {
                default: null,
                parseHTML: element => element.getAttribute('data-block-type'),
                renderHTML: attributes => {
                    return attributes.blockType ? { 'data-block-type': attributes.blockType } : {}
                }
            }
        }
    },

    renderHTML({ node, HTMLAttributes }) {
        const level = node.attrs.level || 1
        const tag = `h${level}`
        
        return [tag, {
            ...HTMLAttributes,
            class: `editor-heading editor-heading-${level} ${HTMLAttributes.class || ''}`,
        }, 0]
    },

    addKeyboardShortcuts() {
        return {
            Enter: ({ editor }) => {
                if (editor.isActive('heading')) {
                    // Create a normal paragraph without any special attributes
                    return editor
                        .chain()
                        .insertContent({ type: 'paragraph' })
                        .run()
                }
                return false
            },
            Backspace: ({ editor }) => {
                // Only handle section headings (level 2 with sectionType)
                if (!editor.isActive('heading', { level: 2 })) {
                    return false
                }

                const { state } = editor
                const { selection } = state
                const { $from } = selection

                // Get the current heading node
                const headingNode = $from.node($from.depth)
                if (!headingNode || !headingNode.attrs.sectionType) {
                    return false
                }

                const headingText = headingNode.textContent

                // Don't delete if heading is already empty (user just created it via / menu)
                if (headingText.length === 0) {
                    return false
                }

                // Check if this backspace will make the heading empty
                const willBeEmptyAfterDelete =
                    (headingText.length === 1 && selection.empty) || // Single char, cursor delete
                    (!selection.empty && selection.$from.pos === $from.start() && selection.$to.pos === $from.end()) // All text selected

                if (willBeEmptyAfterDelete) {
                    // Delete the entire heading node
                    const headingStart = $from.before($from.depth)
                    const headingEnd = $from.after($from.depth)

                    editor.chain()
                        .command(({ tr }) => {
                            tr.delete(headingStart, headingEnd)
                            return true
                        })
                        .run()

                    return true
                }

                return false
            }
        }
    }
})
